import React from 'react';
import ParticipantInfo from '../ParticipantInfo/ParticipantInfo';
import ParticipantTracks from '../ParticipantTracks/ParticipantTracks';
import { Participant as IParticipant } from 'twilio-video';
import {
  PARTICIPANT_LIST_ALLOWED_TRACKS,
  PARTICIPANT_LIST_PRIORITIZED_TRACK,
  PARTICIPANT_MAX_TRACKS,
} from '../../constants';

interface ParticipantProps {
  participant: IParticipant;
  videoOnly?: boolean;
  enableScreenShare?: boolean;
  onClick?: () => void;
  isSelected?: boolean;
  isLocalParticipant?: boolean;
  hideParticipant?: boolean;
}

export default function Participant({
  participant,
  videoOnly,
  enableScreenShare,
  onClick,
  isSelected,
  isLocalParticipant,
  hideParticipant,
}: ParticipantProps) {
  return (
    <ParticipantInfo
      participant={participant}
      onClick={onClick}
      isSelected={isSelected}
      isLocalParticipant={isLocalParticipant}
      hideParticipant={hideParticipant}
    >
      <ParticipantTracks
        participant={participant}
        videoOnly={videoOnly}
        enableScreenShare={enableScreenShare}
        isLocalParticipant={isLocalParticipant}
        allowedTracks={PARTICIPANT_LIST_ALLOWED_TRACKS}
        prioritizedTrack={PARTICIPANT_LIST_PRIORITIZED_TRACK}
        maxTracks={PARTICIPANT_MAX_TRACKS}
      />
    </ParticipantInfo>
  );
}
